import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

const devConfig = {
  apiKey: "AIzaSyBo3aE-gT2w9BJ5zfZJKO5zRF1-w0Q0rGc",
  authDomain: "paul-pro-staging.firebaseapp.com",
  databaseURL: "https://paul-pro-staging.firebaseio.com",
  projectId: "paul-pro-staging",
  storageBucket: "paul-pro-staging.appspot.com",
  messagingSenderId: "73736487471"
};

const prodConfig = {
  apiKey: "AIzaSyCpg-QxhYFCkziYg7YKXraKI6Qe3N8y79k",
  authDomain: "paul-pro-production.firebaseapp.com",
  databaseURL: "https://paul-pro-production.firebaseio.com",
  projectId: "paul-pro-production",
  storageBucket: "paul-pro-production.appspot.com",
  messagingSenderId: "558058170298"
};

const config = process.env.REACT_APP_ENV === 'production'
  ? prodConfig
  : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const db = firebase.database();
const auth = firebase.auth();

export {
  db,
  auth,
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.js